import React from 'react'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import { useAutocompleteName } from '~utils/autocompleteType'
import { Step2AxleDetailsForm } from '@saf/saf-kundenportal-frontend-api/models/Step2AxleDetailsForm'
import { useTranslation } from 'react-i18next'
import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'
import { Box, Divider, Link, Typography } from '@mui/material'
import { useAxleComponentOptions } from '~api/models'
import FormTextFieldNew from '~shared/components/reactHookForm/input/FormTextFieldRedesign'
import { KeyboardArrowDownRounded } from '@mui/icons-material'
import FormAutocompleteMultiple from '~shared/components/reactHookForm/input/FormAutocomplete/FormAutocompleteMultiple'

const Step2AxleDetails: React.FC = () => {
  const gs = useGlobalStyles()
  const acName = useAutocompleteName<Step2AxleDetailsForm>()
  const { t } = useTranslation()
  const axleComponentOptions = useAxleComponentOptions()

  return <>
    <Row className={gs.gridTopMarginFix}>
      <Col xs={12}>
        <Box fontStyle='italic'>
          <Typography variant='h4' component='h2'>
            {t('common:headSpareAxleRequest')}
          </Typography>
          <Divider className={gs.marginBottomTiny} variant='fullWidth' style={{ maxWidth: '125px', backgroundColor: '#000' }} />
          <Typography variant='h5' component='h4' className={gs.marginBottomTiny} color='secondary'>
            {t('common:step2axleDetails')}
          </Typography>
        </Box>
      </Col>
    </Row>
    <Row>
      <Col xs={3}>
        <FormTextFieldNew
          label={t('common:serialNumber')}
          name={acName('serialNumber')}
        />
      </Col>
      <Col xs={2}>
        <Link href='https://youtu.be/zswmjzVL0-Q' target='_blank' fontSize='x-small' color='secondary'>{t('form:linkNeedHelp')}</Link>
      </Col>
    </Row>
    <Row>
      <Col xs={7}>
        <FormAutocompleteMultiple
          className='axleComponentAutocomplete'
          label={t('common:axleComponent')}
          name={acName('axleComponent')}
          options={axleComponentOptions}
          popupIcon={<KeyboardArrowDownRounded />}
        />
      </Col>
    </Row>
    <Row>
      <Col xs={7}>
        <FormTextFieldNew
          label={t('common:optionalInfoText')}
          name={acName('optionalInfo')}
        />
      </Col>
    </Row>
  </>
}

export default Step2AxleDetails
